import styles from "../index.module.less";

export default function Empty({ imageUrl, title }) {
  return (
    <div className={styles.empty}>
      {imageUrl && <img src={imageUrl} alt={"空结果占位图"} />}
      <div>{title}</div>
    </div>
  );
}
